import systemStaffRouter from './system.staff.router';

const routerList2 = [
  // 我的需求  我的待办 详情
  {
    path: '/approval-detail',
    name: 'approvalDetail',
    meta: { id: 0 },
    // eslint-disable-next-line import/no-unresolved
    component: () =>
      import(/* webpackChunkName: "ApprovalDetail" */ '@/views/ApprovalDetail/approveIndex.vue'),
  },
  // 抄送 详情
  {
    path: '/cc-detail',
    name: 'ccDetail',
    meta: { id: 0 },
    // eslint-disable-next-line import/no-unresolved
    component: () =>
      import(/* webpackChunkName: "ApprovalDetail" */ '@/views/ApprovalDetail/CC/approveCC.vue'),
  },
  // 第三方跳转代办详情
  {
    path: '/third-party',
    name: 'thirdParty',
    meta: { id: 0 },
    component: () => import('@/views/ApprovalDetail/approveIndex.vue'),
  },
  // 电子签名
  {
    path: '/elc-sign',
    name: 'elcSign',
    meta: { id: 0 },
    component: () => import(/* webpackChunkName: "Sign" */ '@/views/Sign/index.vue'),
  },
  // 数据中心
  {
    path: '/big-data',
    name: 'bigData',
    meta: { id: '/big-data' },
    component: () => import(/* webpackChunkName: "DataCenter" */ '@/views/DataCenter/index.vue'),
    redirect: '/big-data/standard-report',
    children: [
      // 标准报表
      {
        path: '/big-data/standard-report',
        name: 'standardReport',
        meta: { id: '/big-data' },
        component: () =>
          import(/* webpackChunkName: "standardReport" */ '@/views/DataCenter/DataList/index.vue'),
      },
      // 自助报表
      {
        path: '/big-data/self-help-report',
        name: 'selfHelpReport',
        meta: { id: '/big-data' },
        component: () =>
          import(
            /* webpackChunkName: "self-help-report" */ '@/views/DataCenter/DataList/index.vue'
          ),
      },
    ],
  },
  // 系统管理
  {
    path: '/system',
    name: 'system',
    meta: { id: '/system' },
    component: () => import(/* webpackChunkName: "System" */ '@/views/System/index.vue'),
    children: [
      // 基本设置
      {
        path: '/system/basic-setting',
        name: 'baseSetting',
        meta: { id: '/system/basic-setting' },
        redirect: '/system/basic-setting/language',
        component: () =>
          import(/* webpackChunkName: "basicsetting" */ '@/views/System/BaseSetting/index.vue'),
        children: [
          // 语言
          {
            path: '/system/basic-setting/language',
            name: 'systemLanguage',
            meta: { id: '/system/basic-setting/language' },
            component: () =>
              import(/* webpackChunkName: "language" */ '@/views/System/BaseSetting/Body/body.vue'),
          },
          // 系统菜单
          {
            path: '/system/basic-setting/system-menu',
            name: 'systemMenu',
            meta: { id: '/system/basic-setting/system-menu' },
            component: () =>
              import(
                /* webpackChunkName: "systemMenu" */ '@/views/System/BaseSetting/Body/body.vue'
              ),
          },
          // 主页菜单
          {
            path: '/system/basic-setting/home-menu',
            name: 'homeMenu',
            meta: { id: '/system/basic-setting/home-menu' },
            component: () =>
              import(/* webpackChunkName: "homeMenu" */ '@/views/System/BaseSetting/Body/body.vue'),
          },
          // 国家
          {
            path: '/system/basic-setting/country',
            name: 'country',
            meta: { id: '/system/basic-setting/country' },
            component: () =>
              import(/* webpackChunkName: "country" */ '@/views/System/BaseSetting/Body/body.vue'),
          },
          // 省
          {
            path: '/system/basic-setting/province',
            name: 'province',
            meta: { id: '/system/basic-setting/province' },
            component: () =>
              import(/* webpackChunkName: "province" */ '@/views/System/BaseSetting/Body/body.vue'),
          },
          // 城市
          {
            path: '/system/basic-setting/city',
            name: 'city',
            meta: { id: '/system/basic-setting/city' },
            component: () =>
              import(/* webpackChunkName: "city" */ '@/views/System/BaseSetting/Body/body.vue'),
          },
          // 货币
          {
            path: '/system/basic-setting/currency-setting',
            name: 'currencySetting',
            meta: { id: '/system/basic-setting/currency-setting' },
            redirect: '/system/basic-setting/currency',
            component: () =>
              import(
                /* webpackChunkName: "currencySetting" */ '@/views/System/BaseSetting/Body/body.vue'
              ),
            children: [
              {
                path: '/system/basic-setting/currency',
                name: 'currency',
                meta: { id: '/system/basic-setting/currency' },
                component: () =>
                  import(
                    /* webpackChunkName: "currency" */ '@/views/System/BaseSetting/Body/body.vue'
                  ),
              },
              {
                path: '/system/basic-setting/distribution',
                name: 'distribution',
                meta: { id: '/system/basic-setting/distribution' },
                component: () =>
                  import(
                    /* webpackChunkName: "distribution" */ '@/views/System/BaseSetting/Body/body.vue'
                  ),
              },
            ],
          },
          // 进舍设置
          {
            path: '/system/basic-setting/rounding',
            name: 'rounding',
            meta: { id: '/system/basic-setting/rounding' },
            redirect: '/system/basic-setting/rounding-distribution',
            component: () =>
              import(/* webpackChunkName: "rounding" */ '@/views/System/BaseSetting/Body/body.vue'),
            children: [
              {
                path: '/system/basic-setting/rounding-distribution',
                name: 'roundingDistribution',
                meta: { id: '/system/basic-setting/rounding-distribution' },
                component: () =>
                  import(
                    /* webpackChunkName: "roundingDistribution" */ '@/views/System/BaseSetting/Body/body.vue'
                  ),
              },
              {
                path: '/system/basic-setting/rounding-rules',
                name: 'roundingDistribution',
                meta: { id: '/system/basic-setting/rounding-rules' },
                component: () =>
                  import(
                    /* webpackChunkName: "roundingRules" */ '@/views/System/BaseSetting/Body/body.vue'
                  ),
              },
            ],
          },
          // 金额单位
          {
            path: '/system/basic-setting/sum-unit',
            name: 'sumUnit',
            meta: { id: '/system/basic-setting/sum-unit' },
            component: () =>
              import(/* webpackChunkName: "sumUnit" */ '@/views/System/BaseSetting/Body/body.vue'),
          },
          // 供应商
          {
            path: '/system/basic-setting/supplier',
            name: 'supplier',
            meta: { id: '/system/basic-setting/supplier' },
            component: () =>
              import(/* webpackChunkName: "supplier" */ '@/views/System/BaseSetting/Body/body.vue'),
          },
          // 供应商类型
          {
            path: '/system/basic-setting/supplier-type',
            name: 'supplierType',
            meta: { id: '/system/basic-setting/supplier-type' },
            component: () =>
              import(
                /* webpackChunkName: "supplierType" */ '@/views/System/BaseSetting/Body/body.vue'
              ),
          },
        ],
      },
      // 帮助
      {
        path: '/system/help',
        name: 'systemHelp',
        meta: { id: '/system/help' },
        redirect: '/system/help/help-manual',
        component: () =>
          import(/* webpackChunkName: "systemHelp" */ '@/views/System/Help/index.vue'),
        children: [
          {
            // 帮助-第一层
            path: '/system/help/help-manual',
            name: 'helpManual',
            meta: { id: 0 },
            component: () =>
              import(/* webpackChunkName: "helpManual" */ '@/views/System/Help/Menu/index.vue'),
          },
          {
            // 帮助-第一层
            path: '/system/help/help-manual/edit',
            name: 'edit',
            meta: { id: 0 },
            component: () =>
              import(/* webpackChunkName: "edit" */ '@/views/System/Help/edit/index.vue'),
          },
        ],
      },
      // 员工自助
      {
        path: '/system/message',
        name: 'systemMessage',
        meta: { id: '/system/message' },
        redirect: '/system/message/notice-way',
        component: () =>
          import(/* webpackChunkName: "systemMessage" */ '@/views/System/StaffSelfHelp/index.vue'),
        children: [
          // 通知方式
          {
            path: '/system/message/notice-way',
            name: 'noticeWay',
            meta: { id: '/system/message/notice-way' },
            component: () =>
              import(
                /* webpackChunkName: "noticeWay" */ '@/views/System/StaffSelfHelp/Body/body.vue'
              ),
          },
          // 组织过滤
          {
            path: '/system/message/org-filter',
            name: 'orgFilter',
            meta: { id: '/system/message/org-filter' },
            component: () =>
              import(
                /* webpackChunkName: "noticeWay" */ '@/views/System/StaffSelfHelp/Body/body.vue'
              ),
          },
          // 电子合同类型
          {
            path: '/system/message/elec-contract-type',
            name: 'elcContractType',
            meta: { id: '/system/message/elec-contract-type' },
            component: () =>
              import(
                /* webpackChunkName: "elcContractType" */ '@/views/System/StaffSelfHelp/Body/body.vue'
              ),
          },
          // 电子签类型
          {
            path: '/system/message/elec-sign-type',
            name: 'elcSignType',
            meta: { id: '/system/message/elec-sign-type' },
            component: () =>
              import(
                /* webpackChunkName: "elcSignType" */ '@/views/System/StaffSelfHelp/Body/body.vue'
              ),
          },
          // 服务条款
          {
            path: '/system/message/serviceItem',
            name: 'serviceItem',
            meta: { id: '/system/message/serviceItem' },
            component: () =>
              import(/* webpackChunkName: "serviceItem" */ '@/views/System/ServiceItem/index.vue'),
          },
        ],
      },
      // 自助中心
      {
        path: '/system/self',
        name: 'systemSelf',
        meta: { id: '/system/self' },
        // redirect: '/system/self/require-type',
        component: () =>
          import(/* webpackChunkName: "systemSelf" */ '@/views/System/SelfHelpCenter/index.vue'),
        children: [
          // 需求类别
          {
            path: '/system/self/require-type',
            name: 'requireType',
            meta: { id: '/system/self/require-type' },
            component: () =>
              import(
                /* webpackChunkName: "requireType" */ '@/views/System/SelfHelpCenter/Body/body.vue'
              ),
          },
          // 打卡设置
          {
            path: '/system/self/clock-setting',
            name: 'clockSetting',
            meta: { id: '/system/self/clock-setting' },
            component: () =>
              import(
                /* webpackChunkName: "requireType" */ '@/views/System/SelfHelpCenter/Body/body.vue'
              ),
          },
          // 培训方式
          {
            path: '/system/self/training-method',
            name: 'trainingMethod',
            meta: { id: '/system/self/training-method' },
            component: () =>
              import(
                /* webpackChunkName: "requireType" */ '@/views/System/SelfHelpCenter/Body/body.vue'
              ),
          },

          // 交通工具
          {
            path: '/system/self/pa-vehicle-type',
            name: 'paVehicleType',
            meta: { id: '/system/self/pa-vehicle-type' },
            component: () =>
              import(
                /* webpackChunkName: "requireType" */ '@/views/System/SelfHelpCenter/Body/body.vue'
              ),
          },
          // 车型
          {
            path: '/system/self/vehicle-type',
            name: 'vehicleType',
            meta: { id: '/system/self/vehicle-type' },
            component: () =>
              import(
                /* webpackChunkName: "requireType" */ '@/views/System/SelfHelpCenter/Body/body.vue'
              ),
          },
          // 班车路线
          {
            path: '/system/self/bus',
            name: 'bus',
            meta: { id: '/system/self/bus' },
            component: () =>
              import(
                /* webpackChunkName: "requireType" */ '@/views/System/SelfHelpCenter/Body/body.vue'
              ),
          },
          // 工作餐套餐
          {
            path: '/system/self/meal-type',
            name: 'workMealType',
            meta: { id: '/system/self/meal-type' },
            component: () =>
              import(
                /* webpackChunkName: "workMealType" */ '@/views/System/SelfHelpCenter/Body/body.vue'
              ),
          },
          // 车型
          {
            path: '/system/self/vehicle-type',
            name: 'vehicleType',
            meta: { id: '/system/self/vehicle-type' },
            component: () =>
              import(
                /* webpackChunkName: "workMealType" */ '@/views/System/SelfHelpCenter/Body/body.vue'
              ),
          },
          // 印章类型
          {
            path: '/system/self/seal-type',
            name: 'sealType',
            meta: { id: '/system/self/seal-type' },
            component: () =>
              import(
                /* webpackChunkName: "workMealType" */ '@/views/System/SelfHelpCenter/Body/body.vue'
              ),
          },
          // 文件类型
          {
            path: '/system/self/file-type',
            name: 'fileType',
            meta: { id: '/system/self/file-type' },
            component: () =>
              import(
                /* webpackChunkName: "workMealType" */ '@/views/System/SelfHelpCenter/Body/body.vue'
              ),
          },
          // 报销类别
          {
            path: '/system/self/reimbursement',
            name: 'reimbursement',
            meta: { id: '/system/self/reimbursement' },
            component: () =>
              import(
                /* webpackChunkName: "workMealType" */ '@/views/System/SelfHelpCenter/Body/body.vue'
              ),
          },
          // 付款方式
          {
            path: '/system/self/payment',
            name: 'payment',
            meta: { id: '/system/self/payment' },
            component: () =>
              import(
                /* webpackChunkName: "payment" */ '@/views/System/SelfHelpCenter/Body/body.vue'
              ),
          },
        ],
      },
      // 入职管理
      {
        path: '/system/entry',
        name: 'systemEntry',
        meta: { id: '/system/entry' },
        redirect: '/system/entry/status',
        component: () =>
          import(/* webpackChunkName: "systemEntry" */ '@/views/System/EntryManagement/index.vue'),
        children: [
          {
            path: '/system/entry/status',
            name: 'entryStatus',
            meta: { id: '/system/entry/status' },
            component: () =>
              import(
                /* webpackChunkName: "entryStatus" */ '@/views/System/EntryManagement/Body/body.vue'
              ),
          },
        ],
      },
      // 员工管理
      {
        path: '/system/staff',
        name: 'systemStaff',
        meta: { id: '/system/staff' },
        redirect: '/system/staff/info-type',
        component: () =>
          import(/* webpackChunkName: "systemStaff" */ '@/views/System/StaffManagement/index.vue'),
        children: systemStaffRouter,
      },
      // 组织管理
      {
        path: '/system/organization',
        name: 'systemOrganization',
        meta: { id: '/system/organization' },
        redirect: '/system/org/company',
        component: () =>
          import(
            /* webpackChunkName: "systemOrganization" */ '@/views/System/Organization/index.vue'
          ),
        children: [
          {
            // 公司
            path: '/system/org/company',
            name: 'systemCompany',
            meta: { id: '/system/org/company' },
            component: () =>
              import(
                /* webpackChunkName: "systemCompany" */ '@/views/System/Organization/Body/body.vue'
              ),
          },
          {
            // 组织类型
            path: '/system/org/org-type',
            name: 'systemOrgType',
            meta: { id: '/system/org/org-type' },
            component: () =>
              import(
                /* webpackChunkName: "systemOrgType" */ '@/views/System/Organization/Body/body.vue'
              ),
          },
          {
            // 成本中心
            path: '/system/org/cost-center',
            name: 'systemCostCenter',
            meta: { id: '/system/org/cost-center' },
            component: () =>
              import(
                /* webpackChunkName: "systemCostCenter" */ '@/views/System/Organization/Body/body.vue'
              ),
          },
          {
            // 职位
            path: '/system/org/position',
            name: 'systemPosition',
            meta: { id: '/system/org/position' },
            component: () =>
              import(
                /* webpackChunkName: "systemPosition" */ '@/views/System/Organization/Body/body.vue'
              ),
          },
          {
            // 职能
            path: '/system/org/function',
            name: 'systemFunction',
            meta: { id: '/system/org/function' },
            component: () =>
              import(
                /* webpackChunkName: "systemFunction" */ '@/views/System/Organization/Body/body.vue'
              ),
          },
          {
            // 职级
            path: '/system/org/position-rank',
            name: 'systemPositionRank',
            meta: { id: '/system/org/position-rank' },
            component: () =>
              import(
                /* webpackChunkName: "systemPositionRank" */ '@/views/System/Organization/Body/body.vue'
              ),
          },
          {
            // 职等
            path: '/system/org/grade',
            name: 'systemGrade',
            meta: { id: '/system/org/grade' },
            component: () =>
              import(
                /* webpackChunkName: "systemPositionRank" */ '@/views/System/Organization/Body/body.vue'
              ),
          },
          {
            // 关键岗位
            path: '/system/org/key-job',
            name: 'systemKeyJob',
            meta: { id: '/system/org/key-job' },
            component: () =>
              import(
                /* webpackChunkName: "systemKeyJob" */ '@/views/System/Organization/Body/body.vue'
              ),
          },
          {
            // 岗位类别
            path: '/system/org/position-type',
            name: 'systemPositionType',
            meta: { id: '/system/org/position-type' },
            component: () =>
              import(
                /* webpackChunkName: "systemPositionType" */ '@/views/System/Organization/Body/body.vue'
              ),
          },
        ],
      },
      // 考勤管理
      {
        path: '/system/time',
        name: 'systemTime',
        meta: { id: '/system/time' },
        redirect: '/system/time/attendance',
        component: () =>
          import(/* webpackChunkName: "systemTime" */ '@/views/System/attendance/index.vue'),
        children: [
          {
            // 工作计划
            path: '/system/time/schedule',
            name: 'systemSchedule',
            meta: { id: '/system/time/schedule' },
            component: () =>
              import(
                /* webpackChunkName: "systemSchedule" */ '@/views/System/attendance/Body/body.vue'
              ),
          },
          {
            // 班次
            path: '/system/time/shift',
            name: 'systemShift',
            meta: { id: '/system/time/shift' },
            component: () =>
              import(
                /* webpackChunkName: "systemShift" */ '@/views/System/attendance/Body/body.vue'
              ),
          },
          {
            // 公共假日
            path: '/system/time/holiday',
            name: 'systemHoliday',
            meta: { id: '/system/time/holiday' },
            component: () =>
              import(
                /* webpackChunkName: "systemHoliday" */ '@/views/System/attendance/Body/body.vue'
              ),
          },
          {
            // 评估类型
            path: '/system/time/evaluation-type',
            name: 'systemEvaluationType',
            meta: { id: '/system/time/evaluation-type' },
            component: () =>
              import(
                /* webpackChunkName: "systemEvaluationType" */ '@/views/System/attendance/Body/body.vue'
              ),
          },
          {
            // 出勤类型
            path: '/system/time/event-type',
            name: 'systemEventType',
            meta: { id: '/system/time/event-type' },
            component: () =>
              import(
                /* webpackChunkName: "systemEventType" */ '@/views/System/attendance/Body/body.vue'
              ),
          },
          {
            // 打卡
            path: '/system/time/clock-in',
            name: 'systemClockIn',
            meta: { id: '/system/time/clock-in' },
            component: () =>
              import(
                /* webpackChunkName: "systemClockIn" */ '@/views/System/attendance/Body/body.vue'
              ),
          },
          {
            // 假期类型
            path: '/system/time/leave-type',
            name: 'systemLeaveType',
            meta: { id: '/system/time/leave-type' },
            component: () =>
              import(
                /* webpackChunkName: "systemLeaveType" */ '@/views/System/attendance/Body/body.vue'
              ),
          },
          {
            // 加班规则
            path: '/system/time/overtime-rule',
            name: 'systemOvertimeRule',
            meta: { id: '/system/time/overtime-rule' },
            component: () =>
              import(
                /* webpackChunkName: "systemOvertimeRule" */ '@/views/System/attendance/Body/body.vue'
              ),
          },
          {
            // 考勤数据类型
            path: '/system/time/attendance-data_type',
            name: 'systemAttendanceDataType',
            meta: { id: '/system/time/attendance-data_type' },
            component: () =>
              import(
                /* webpackChunkName: "systemAttendanceDataType" */ '@/views/System/attendance/Body/body.vue'
              ),
          },
          {
            // 考勤评估流程
            path: '/system/time/evaluation-proc',
            name: 'systemEvaluationProc',
            meta: { id: '/system/time/evaluation-proc' },
            component: () =>
              import(
                /* webpackChunkName: "systemEvaluationProc" */ '@/views/System/attendance/Body/body.vue'
              ),
          },
          {
            // 考勤评估单
            path: '/system/time/evaluation-sheet',
            name: 'systemEvaluationSheet',
            meta: { id: '/system/time/evaluation-sheet' },
            component: () =>
              import(
                /* webpackChunkName: "systemEvaluationSheet" */ '@/views/System/attendance/Body/body.vue'
              ),
          },
          {
            // 综合工时
            path: '/system/time/integrated-working_hour',
            name: 'systemIntegratedWorkingHour',
            meta: { id: '/system/time/integrated-working_hour' },
            component: () =>
              import(
                /* webpackChunkName: "systemIntegratedWorkingHour" */ '@/views/System/attendance/Body/body.vue'
              ),
          },
          {
            // 综合工时
            path: '/system/time/day_class',
            name: 'systemDayClass',
            meta: { id: '/system/time/day_class' },
            component: () =>
              import(
                /* webpackChunkName: "systemIntegratedWorkingHour" */ '@/views/System/attendance/Body/body.vue'
              ),
          },
        ],
      },
      // 薪资管理
      {
        path: '/system/payroll',
        name: 'systemPayroll',
        meta: { id: '/system/payroll' },
        redirect: '/system/time/attendance',
        component: () =>
          import(/* webpackChunkName: "systemTime" */ '@/views/System/payroll/index.vue'),
        children: [
          {
            // 社保公积金
            path: '/system/payroll/social-insurance',
            name: 'socialInsurance',
            meta: { id: '/system/payroll/social-insurance' },
            component: () =>
              import(
                /* webpackChunkName: "socialInsurance" */ '@/views/System/payroll/Body/body.vue'
              ),
          },
          {
            // 税阶
            path: '/system/payroll/tax-rank',
            name: 'taxRank',
            meta: { id: '/system/payroll/tax-rank' },
            component: () =>
              import(/* webpackChunkName: "taxRank" */ '@/views/System/payroll/Body/body.vue'),
          },
          {
            // 薪资项
            path: '/system/payroll/wage-type',
            name: 'wageType',
            meta: { id: '/system/payroll/wage-type' },
            component: () =>
              import(/* webpackChunkName: "wageType" */ '@/views/System/payroll/Body/body.vue'),
          },
          {
            // 算薪分组
            path: '/system/payroll/payroll-group',
            name: 'payrollGroup',
            meta: { id: '/system/payroll/payroll-group' },
            component: () =>
              import(/* webpackChunkName: "payrollGroup" */ '@/views/System/payroll/Body/body.vue'),
          },
          {
            // 账户授权
            path: '/system/payroll/account-authorization',
            name: 'accountAuthorization',
            meta: { id: '/system/payroll/account-authorization' },
            component: () =>
              import(
                /* webpackChunkName: "accountAuthorization" */ '@/views/System/payroll/Body/body.vue'
              ),
          },
          {
            // 算薪流程
            path: '/system/payroll/payroll-proc',
            name: 'payrollProc',
            meta: { id: '/system/payroll/payroll-proc' },
            component: () =>
              import(/* webpackChunkName: "payrollProc" */ '@/views/System/payroll/Body/body.vue'),
          },
          {
            // 工资单
            path: '/system/payroll/salary-sheet',
            name: 'salarySheet',
            meta: { id: '/system/payroll/salary-sheet' },
            component: () =>
              import(/* webpackChunkName: "salarySheet" */ '@/views/System/payroll/Body/body.vue'),
          },
          {
            // 招行订单
            path: '/system/payroll/cmb-order',
            name: 'cmbOrder',
            meta: { id: '/system/payroll/cmb-order' },
            component: () =>
              import(/* webpackChunkName: "cmbOrder" */ '@/views/System/payroll/Body/body.vue'),
          },
          {
            // 招行订单
            path: '/system/payroll/alipay-order',
            name: 'alipayOrde',
            meta: { id: '/system/payroll/alipay-order' },
            component: () =>
              import(/* webpackChunkName: "alipayOrde" */ '@/views/System/payroll/Body/body.vue'),
          },
        ],
      },

      // 薪资管理
      // {
      //   path: '/system/payroll',
      //   name: 'systemPayroll',
      //   meta: { id: '/system/payroll' },
      //   redirect: '/system/payroll/salary',
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "systemPayroll" */ '@/views/System/SalaryManagement/businessPrint.vue'
      //     ),
      //   children: [
      //     {
      //       path: '/system/payroll/salary',
      //       name: 'payrollSalary',
      //       meta: { id: '/system/payroll/salary' },
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "payrollSalary" */ '@/views/System/SalaryManagement/Body/body.vue'
      //         ),
      //     },
      //     {
      //       path: '/system/payroll/group-type',
      //       name: 'payrollGroupType',
      //       meta: { id: '/system/payroll/group-type' },
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "payrollGroupType" */ '@/views/System/SalaryManagement/Body/body.vue'
      //         ),
      //     },
      //     {
      //       path: '/system/payroll/group',
      //       name: 'payrollGroup',
      //       meta: { id: '/system/payroll/group' },
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "payrollGroup" */ '@/views/System/SalaryManagement/Body/body.vue'
      //         ),
      //     },
      //     {
      //       path: '/system/payroll/wage-manage',
      //       name: 'wageManage',
      //       meta: { id: '/system/payroll/wage-manage' },
      //       redirect: '/system/wage-manage/type',
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "wageManage" */ '@/views/System/SalaryManagement/Body/body.vue'
      //         ),
      //       children: [
      //         {
      //           path: '/system/wage-manage/type',
      //           name: 'wageManageType',
      //           meta: { id: '/system/wage-manage/type' },
      //           component: () =>
      //             import(
      //               /* webpackChunkName: "wageManageType" */ '@/views/System/SalaryManagement/Body/body.vue'
      //             ),
      //         },
      //         {
      //           path: '/system/wage-manage/wage',
      //           name: 'wageManageWage',
      //           meta: { id: '/system/wage-manage/wage' },
      //           component: () =>
      //             import(
      //               /* webpackChunkName: "wageManageWage" */ '@/views/System/SalaryManagement/Body/body.vue'
      //             ),
      //         },
      //       ],
      //     },
      //     {
      //       path: '/system/payroll/account-authorization',
      //       name: 'accountAuthorization',
      //       meta: { id: '/system/payroll/account-authorization' },
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "accountAuthorization" */ '@/views/System/SalaryManagement/Body/body.vue'
      //         ),
      //     },
      //   ],
      // },
      // 电子合同
      {
        path: '/system/contract',
        name: 'Contract',
        meta: { id: '/system/contract' },
        redirect: '/contract/company',
        component: () =>
          import(/* webpackChunkName: "Contract" */ '@/views/System/ElectronicContract/index.vue'),
        children: [
          {
            path: '/contract/company',
            name: 'companyContract',
            meta: { id: '/contract/company' },
            component: () =>
              import(
                /* webpackChunkName: "companyContract" */ '@/views/System/ElectronicContract/Company/index.vue'
              ),
          },
          {
            path: '/contract/staff',
            name: 'staffContract',
            meta: { id: '/contract/staff' },
            component: () =>
              import(
                /* webpackChunkName: "staffContract" */ '@/views/System/ElectronicContract/Company/index.vue'
              ),
          },
          {
            path: '/contract/template',
            name: 'templateContract',
            meta: { id: '/contract/template' },
            component: () =>
              import(
                /* webpackChunkName: "templateContract" */ '@/views/System/ElectronicContract/Company/index.vue'
              ),
          },
        ],
      },
      // 定时任务
      {
        path: '/system/cron-jobs',
        name: 'timedTask',
        meta: { id: '/system/cron-jobs' },
        component: () =>
          import(/* webpackChunkName: "timedTask" */ '@/views/System/TimedTask/index.vue'),
      },
      // 权限设置
      {
        path: '/system/authorization',
        name: 'authorization',
        meta: { id: '/system/authorization' },
        redirect: '/system/basic-setting/language',
        component: () =>
          import(/* webpackChunkName: "authorization" */ '@/views/System/AuthSetting/index.vue'),
        children: [
          // 基本设置
          {
            path: '/system/authorization/base-setting',
            name: 'authBaseSetting',
            meta: { id: '/system/authorization/base-setting' },
            component: () =>
              import(
                /* webpackChunkName: "authBaseSetting" */ '@/views/System/AuthSetting/authBody/body.vue'
              ),
          },
          // 用户
          {
            path: '/system/authorization/user',
            name: 'authUser',
            meta: { id: '/system/authorization/user' },
            component: () =>
              import(
                /* webpackChunkName: "authUser" */ '@/views/System/AuthSetting/authBody/body.vue'
              ),
          },
          // 用户组
          {
            path: '/system/authorization/user-group',
            name: 'authUserGroup',
            meta: { id: '/system/authorization/user-group' },
            component: () =>
              import(
                /* webpackChunkName: "authUserGroup" */ '@/views/System/AuthSetting/authBody/body.vue'
              ),
          },
          // 组织权限
          {
            path: '/system/authorization/organization',
            name: 'authOrganization',
            meta: { id: '/system/authorization/organization' },
            component: () =>
              import(
                /* webpackChunkName: "authOrganization" */ '@/views/System/AuthSetting/authBody/body.vue'
              ),
          },
          // 角色管理
          {
            path: '/system/authorization/role-manage',
            name: 'authRoleManage',
            meta: { id: '/system/authorization/role-manage' },
            component: () =>
              import(
                /* webpackChunkName: "authRoleManage" */ '@/views/System/AuthSetting/Role/body.vue'
              ),
          },
          // 代理设置
          {
            path: '/system/authorization/proxy-setting',
            name: 'authProxySetting',
            meta: { id: '/system/authorization/proxy-setting' },
            component: () =>
              import(
                /* webpackChunkName: "authProxySetting" */ '@/views/System/AuthSetting/authBody/body.vue'
              ),
          },
        ],
      },
      // 行政管理
      {
        path: '/system/office-admin',
        name: 'systemOfficeAdmin',
        meta: { id: '/system/office-admin' },
        redirect: '/system/item-type',
        component: () =>
          import(/* webpackChunkName: "systemOfficeAdmin" */ '@/views/System/OfficeAdmin/index.vue'),
        children: [
          {
            path: '/system/item-type',
            name: 'itemType',
            meta: { id: '/system/item-type' },
            component: () =>
              import(/* webpackChunkName: "itemType" */ '@/views/System/OfficeAdmin/Body/body.vue'),
          },
          {
            path: '/system/cabinet-type',
            name: 'cabinetType',
            meta: { id: '/system/cabinet-type' },
            component: () =>
              import(/* webpackChunkName: "cabinetType" */ '@/views/System/OfficeAdmin/Body/body.vue'),
          },
          {
            path: '/system/cost-type',
            name: 'costType',
            meta: { id: '/system/cost-type' },
            component: () =>
              import(/* webpackChunkName: "costType" */ '@/views/System/OfficeAdmin/Body/body.vue'),
          },
        ],
      },
    ],
  },
  // 客户定制化页面
  // 强盛印染项目
  {
    path: '/qs-project',
    name: 'qsProject',
    meta: { id: '/qs-project' },
    component: () =>
      import(
        /* webpackChunkName: "qsProject" */ '@/views/CompanyCustPage/QiangShengYR/projectList.vue'
      ),
  },
];
export default routerList2;
